<div [class.reimburse]="+taxWithheld.taxAmountFiat < 0 || +taxWithheld.taxAmountAsset < 0">
  <!-- FIAT type -->
  @if (type === 'FIAT' || !taxWithheld.taxAmountAsset) {
    <span>
      &asymp;&nbsp;
      {{
      taxWithheld.taxAmountFiat
      | absolute
      | fiat_precision_symbol
      : {
      id: taxWithheld.fiatId,
      symbol: true
    }
    }}
    {{ (+taxWithheld.taxAmountFiat >= 0 ? "tw_tax_amount" : "tax_reimbursement") | translate }}
  </span>
} @else {
  <span>
    &asymp;&nbsp;
    {{
    taxWithheld.taxAmountAsset
    | absolute
    | tradable_precision_symbol: { id: taxWithheld.assetId, ignorePrecision: true }
    }}
    {{ (+taxWithheld.taxAmountAsset >= 0 ? "tw_tax_amount" : "tax_reimbursement") | translate }}
  </span>
}
<!-- ASSET type -->
</div>
